import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
/**
 * テキストエリア コンポーネント (スケルトン表示)
 * @param props
 * @returns
 */
export const TextInputSkeleton = (props) => {
    const { className = '' } = props;
    return _jsx(Skeleton, { className: clsx('w-full h-[44px] rounded-md', className) });
};
